import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../../Components/Common/ChartsDynamicColor";
import { CloudCog } from "lucide-react";

const RequestChart = ({ dataColors, chartData }) => {
  const colors = getChartColorsArray(dataColors);
  console.log(chartData)
  // Safety check: return null if no data
  if (!chartData || chartData.length === 0) {
    return <div>No data available</div>;
  }
  
  // Transform the data to ApexCharts format
  const categories = chartData.map(item => item.label);
  const series = [{
    data: chartData.map(item => item.value)
  }];

  const options = {
    chart: {
      type: "bar",
      height: 436,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true,
      },
    },
    colors,
    dataLabels: {
      enabled: true,
      offsetX: 30,
      style: {
        fontSize: "12px",
        colors: ["#547a9fff"],
      },
    },
    legend: {
      show: false,
    },
    grid: {
      show: false,
    },
    xaxis: {
      categories: categories,
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bar"
      height={650}
    />
  );
};

export default RequestChart;

